// Should stay in sync with dataDownloadTypes.mjs
export const DATA_DOWNLOAD_TYPES = {
  appraisal: 'appraisal',
  checkPoint: 'checkPoint',
  eventComment: 'eventComment',
  strengthsAndChallenges: 'strengthsAndChallenges',
  executiveSummary: 'executiveSummary',
  surveyResults: 'surveyResults',
  deDuplicatedMetrics: 'deDuplicatedMetrics',
  aggregatePerformanceReport: 'aggregatePerformanceReport'
};
